/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChatExportListResponseDto,
  ChatExportResponseDto,
  ChatRequestDto,
  ChatbotConversationResponseDto,
  DeleteChatExportResponseDto,
  ErrorResponse,
  PaginatedMessagesResponseDto,
  SSEEventDto,
  UpdateConversationTitleDto,
  UpdateShareExportResponseDto,
  UpdateShareStatusDto,
} from '../models/index';
import {
    ChatExportListResponseDtoFromJSON,
    ChatExportListResponseDtoToJSON,
    ChatExportResponseDtoFromJSON,
    ChatExportResponseDtoToJSON,
    ChatRequestDtoFromJSON,
    ChatRequestDtoToJSON,
    ChatbotConversationResponseDtoFromJSON,
    ChatbotConversationResponseDtoToJSON,
    DeleteChatExportResponseDtoFromJSON,
    DeleteChatExportResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PaginatedMessagesResponseDtoFromJSON,
    PaginatedMessagesResponseDtoToJSON,
    SSEEventDtoFromJSON,
    SSEEventDtoToJSON,
    UpdateConversationTitleDtoFromJSON,
    UpdateConversationTitleDtoToJSON,
    UpdateShareExportResponseDtoFromJSON,
    UpdateShareExportResponseDtoToJSON,
    UpdateShareStatusDtoFromJSON,
    UpdateShareStatusDtoToJSON,
} from '../models/index';

export interface ChatBotRequest {
    chatRequestDto: ChatRequestDto;
}

export interface ChatbotDeleteConversationRequest {
    conversationId: string;
}

export interface ChatbotDeleteExportRequest {
    exportId: string;
}

export interface ChatbotExportConversationRequest {
    conversationId: string;
}

export interface ChatbotGetExportsRequest {
    page?: number;
    pageSize?: number;
    search?: string;
    sortField?: ChatbotGetExportsSortFieldEnum;
    sortOrder?: ChatbotGetExportsSortOrderEnum;
}

export interface ChatbotGetMessagesRequest {
    conversationId: string;
    nextPageToken?: string;
    pageSize?: number;
}

export interface ChatbotUpdateShareExportRequest {
    exportId: string;
    updateShareStatusDto: UpdateShareStatusDto;
}

export interface ChatbotUpdateTitleRequest {
    conversationId: string;
    updateConversationTitleDto: UpdateConversationTitleDto;
}

/**
 * 
 */
export class ChatbotApi extends runtime.BaseAPI {

    /**
     * Supports SSE streaming (Accept: text/event-stream) for real-time chat responses with file attachments (images, documents, audio, video)
     * Send message with optional files to Gemini 2.5 Pro chatbot
     */
    async chatBotRaw(requestParameters: ChatBotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SSEEventDto>> {
        if (requestParameters['chatRequestDto'] == null) {
            throw new runtime.RequiredError(
                'chatRequestDto',
                'Required parameter "chatRequestDto" was null or undefined when calling chatBot().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chatbot/chat`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChatRequestDtoToJSON(requestParameters['chatRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SSEEventDtoFromJSON(jsonValue));
    }

    /**
     * Supports SSE streaming (Accept: text/event-stream) for real-time chat responses with file attachments (images, documents, audio, video)
     * Send message with optional files to Gemini 2.5 Pro chatbot
     */
    async chatBot(requestParameters: ChatBotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SSEEventDto> {
        const response = await this.chatBotRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a specific conversation and all its messages
     * Delete conversation
     */
    async chatbotDeleteConversationRaw(requestParameters: ChatbotDeleteConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['conversationId'] == null) {
            throw new runtime.RequiredError(
                'conversationId',
                'Required parameter "conversationId" was null or undefined when calling chatbotDeleteConversation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chatbot/conversations/{conversationId}`.replace(`{${"conversationId"}}`, encodeURIComponent(String(requestParameters['conversationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a specific conversation and all its messages
     * Delete conversation
     */
    async chatbotDeleteConversation(requestParameters: ChatbotDeleteConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.chatbotDeleteConversationRaw(requestParameters, initOverrides);
    }

    /**
     * Marks a chat export as deleted. The underlying file is preserved for audit purposes.
     * Soft delete a chat export
     */
    async chatbotDeleteExportRaw(requestParameters: ChatbotDeleteExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteChatExportResponseDto>> {
        if (requestParameters['exportId'] == null) {
            throw new runtime.RequiredError(
                'exportId',
                'Required parameter "exportId" was null or undefined when calling chatbotDeleteExport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chatbot/exports/{exportId}`.replace(`{${"exportId"}}`, encodeURIComponent(String(requestParameters['exportId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteChatExportResponseDtoFromJSON(jsonValue));
    }

    /**
     * Marks a chat export as deleted. The underlying file is preserved for audit purposes.
     * Soft delete a chat export
     */
    async chatbotDeleteExport(requestParameters: ChatbotDeleteExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteChatExportResponseDto> {
        const response = await this.chatbotDeleteExportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Exports the chatbot patient\'s conversation as a document, uploads it to storage, and saves the export metadata
     * Export a chatbot conversation
     */
    async chatbotExportConversationRaw(requestParameters: ChatbotExportConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatExportResponseDto>> {
        if (requestParameters['conversationId'] == null) {
            throw new runtime.RequiredError(
                'conversationId',
                'Required parameter "conversationId" was null or undefined when calling chatbotExportConversation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chatbot/conversations/{conversationId}/export`.replace(`{${"conversationId"}}`, encodeURIComponent(String(requestParameters['conversationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatExportResponseDtoFromJSON(jsonValue));
    }

    /**
     * Exports the chatbot patient\'s conversation as a document, uploads it to storage, and saves the export metadata
     * Export a chatbot conversation
     */
    async chatbotExportConversation(requestParameters: ChatbotExportConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatExportResponseDto> {
        const response = await this.chatbotExportConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all conversations for the authenticated user
     * Get user\'s conversations
     */
    async chatbotGetConversationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ChatbotConversationResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chatbot/conversations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ChatbotConversationResponseDtoFromJSON));
    }

    /**
     * Retrieve all conversations for the authenticated user
     * Get user\'s conversations
     */
    async chatbotGetConversations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChatbotConversationResponseDto>> {
        const response = await this.chatbotGetConversationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a paginated list of exported chat files for the authenticated patient, with optional search by file name and sorting by export time
     * Get list of exported chats
     */
    async chatbotGetExportsRaw(requestParameters: ChatbotGetExportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatExportListResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sortField'] != null) {
            queryParameters['sortField'] = requestParameters['sortField'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chatbot/exports`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatExportListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves a paginated list of exported chat files for the authenticated patient, with optional search by file name and sorting by export time
     * Get list of exported chats
     */
    async chatbotGetExports(requestParameters: ChatbotGetExportsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatExportListResponseDto> {
        const response = await this.chatbotGetExportsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve paginated messages from a specific conversation
     * Get conversation messages with pagination
     */
    async chatbotGetMessagesRaw(requestParameters: ChatbotGetMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedMessagesResponseDto>> {
        if (requestParameters['conversationId'] == null) {
            throw new runtime.RequiredError(
                'conversationId',
                'Required parameter "conversationId" was null or undefined when calling chatbotGetMessages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['nextPageToken'] != null) {
            queryParameters['nextPageToken'] = requestParameters['nextPageToken'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chatbot/conversations/{conversationId}/messages`.replace(`{${"conversationId"}}`, encodeURIComponent(String(requestParameters['conversationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedMessagesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve paginated messages from a specific conversation
     * Get conversation messages with pagination
     */
    async chatbotGetMessages(requestParameters: ChatbotGetMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedMessagesResponseDto> {
        const response = await this.chatbotGetMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sets the isSharedWithProvider flag on a chat export, controlling its visibility in the doctor portal
     * Update share status of exported chat with provider
     */
    async chatbotUpdateShareExportRaw(requestParameters: ChatbotUpdateShareExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateShareExportResponseDto>> {
        if (requestParameters['exportId'] == null) {
            throw new runtime.RequiredError(
                'exportId',
                'Required parameter "exportId" was null or undefined when calling chatbotUpdateShareExport().'
            );
        }

        if (requestParameters['updateShareStatusDto'] == null) {
            throw new runtime.RequiredError(
                'updateShareStatusDto',
                'Required parameter "updateShareStatusDto" was null or undefined when calling chatbotUpdateShareExport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chatbot/exports/{exportId}/share-status`.replace(`{${"exportId"}}`, encodeURIComponent(String(requestParameters['exportId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateShareStatusDtoToJSON(requestParameters['updateShareStatusDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateShareExportResponseDtoFromJSON(jsonValue));
    }

    /**
     * Sets the isSharedWithProvider flag on a chat export, controlling its visibility in the doctor portal
     * Update share status of exported chat with provider
     */
    async chatbotUpdateShareExport(requestParameters: ChatbotUpdateShareExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateShareExportResponseDto> {
        const response = await this.chatbotUpdateShareExportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the title of a specific conversation. If no title is provided, generates one based on the first user message.
     * Update or generate conversation title
     */
    async chatbotUpdateTitleRaw(requestParameters: ChatbotUpdateTitleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatbotConversationResponseDto>> {
        if (requestParameters['conversationId'] == null) {
            throw new runtime.RequiredError(
                'conversationId',
                'Required parameter "conversationId" was null or undefined when calling chatbotUpdateTitle().'
            );
        }

        if (requestParameters['updateConversationTitleDto'] == null) {
            throw new runtime.RequiredError(
                'updateConversationTitleDto',
                'Required parameter "updateConversationTitleDto" was null or undefined when calling chatbotUpdateTitle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chatbot/conversations/{conversationId}`.replace(`{${"conversationId"}}`, encodeURIComponent(String(requestParameters['conversationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateConversationTitleDtoToJSON(requestParameters['updateConversationTitleDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatbotConversationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update the title of a specific conversation. If no title is provided, generates one based on the first user message.
     * Update or generate conversation title
     */
    async chatbotUpdateTitle(requestParameters: ChatbotUpdateTitleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatbotConversationResponseDto> {
        const response = await this.chatbotUpdateTitleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ChatbotGetExportsSortFieldEnum = {
    ExportedAt: 'exported_at',
    FileName: 'file_name'
} as const;
export type ChatbotGetExportsSortFieldEnum = typeof ChatbotGetExportsSortFieldEnum[keyof typeof ChatbotGetExportsSortFieldEnum];
/**
 * @export
 */
export const ChatbotGetExportsSortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type ChatbotGetExportsSortOrderEnum = typeof ChatbotGetExportsSortOrderEnum[keyof typeof ChatbotGetExportsSortOrderEnum];
